"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fixOneoffs = fixOneoffs;
function fixOneoffs(tex) {
    return (tex
        // eslint-disable-next-line no-control-regex
        .replace(/[\x00-\x08\v\f\x0e-\x1f\x7f]/g, "")
        .replace(/\\text_/g, "\\text{\\_}")
        .replace(/\\cancel\s*{\s*\\text{}\s*}/g, "")
        .replace("\\text €", "\\text{€}")
        .replace(/^\\€/, "€")
        .replace("\\textbf{x_0}", "\\mathbf{x_0}")
        .replace("\\overline{}2~367=2×q+r", "2~367=2×q+r"));
}
